module.exports = __webpack_public_path__ + "static/media/goto_demo_mobile.5ccb885d.svg";